var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9015 1.38955C21.8938 1.65982 22.6753 2.45623 22.9405 3.46744C23.4225 5.30033 23.4225 9.12449 23.4225 9.12449C23.4225 9.12449 23.4225 12.9486 22.9405 14.7815C22.6753 15.7927 21.8938 16.556 20.9015 16.8262C19.1029 17.3174 11.8909 17.3174 11.8909 17.3174C11.8909 17.3174 4.67893 17.3174 2.88032 16.8262C1.88805 16.556 1.10655 15.7927 0.841301 14.7815C0.359375 12.9486 0.359375 9.12449 0.359375 9.12449C0.359375 9.12449 0.359375 5.30033 0.841301 3.46744C1.10655 2.45623 1.88805 1.65986 2.88032 1.38955C4.67893 0.898438 11.8909 0.898438 11.8909 0.898438C11.8909 0.898438 19.103 0.898438 20.9015 1.38955ZM15.56 9.12457L9.53218 5.65244V12.5965L15.56 9.12457Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9015 1.38955C21.8938 1.65982 22.6753 2.45623 22.9405 3.46744C23.4225 5.30033 23.4225 9.12449 23.4225 9.12449C23.4225 9.12449 23.4225 12.9486 22.9405 14.7815C22.6753 15.7927 21.8938 16.556 20.9015 16.8262C19.1029 17.3174 11.8909 17.3174 11.8909 17.3174C11.8909 17.3174 4.67893 17.3174 2.88032 16.8262C1.88805 16.556 1.10655 15.7927 0.841301 14.7815C0.359375 12.9486 0.359375 9.12449 0.359375 9.12449C0.359375 9.12449 0.359375 5.30033 0.841301 3.46744C1.10655 2.45623 1.88805 1.65986 2.88032 1.38955C4.67893 0.898438 11.8909 0.898438 11.8909 0.898438C11.8909 0.898438 19.103 0.898438 20.9015 1.38955ZM15.56 9.12457L9.53218 5.65244V12.5965L15.56 9.12457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_519)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7f665f4986f577a2d523d0068ce1ee7c.svg";
export { ForwardRef as ReactComponent };